$(document).ready(function() {
  var orderConfirmationText = '.ph-orderconfirmation__tooltip--text';

  $(document).on('click mouseover', '.ph-orderconfirmation__tooltip', function() {
    $(orderConfirmationText).toggleClass('hidden');

    var mobWidth = $(window).width();

    if (mobWidth < 450) {
      $(orderConfirmationText).css({
        width: mobWidth - 20
      });
    }

    if (mobWidth <= 768) {
      $('.ph-orderconfirmation__crossicon').removeClass('hidden');
    } else {
      $('.ph-orderconfirmation__crossicon').addClass('hidden');
    }
  }).on('mouseout', function() {
    $(orderConfirmationText).addClass('hidden');
  });

  $('.ph-cartpage-savings__tooltip').on('click', function() {
    $('.ph-cartpage-savings__tooltip_text').toggleClass('hidden');

    var mobWidth = $(window).width();

    if (mobWidth < 768) {
      $('.ph-cartpage-savings__tooltip_text').css({
        width: mobWidth - 20
      });
    }

    if (mobWidth <= 768) {
      $('.ph-promotion_crossicon').removeClass('hidden');
    } else {
      $('.ph-promotion_crossicon').addClass('hidden');
    }
  });

  $('.ph-cartpage-promotion-lineitem__tooltip').on('click', function() {
    var itemParent = $(this).closest('.ph-itemproduct');

    itemParent.find('.ph-cartpage-promotion-lineitem__tooltip_text').toggleClass('hidden');
    itemParent.siblings().find('.ph-cartpage-promotion-lineitem__tooltip_text').addClass('hidden');

    var mobWidth = $(window).width();

    if (mobWidth < 768) {
      $('.ph-cartpage-promotion-lineitem__tooltip_text').css({
        width: mobWidth - 20,
        left: 0 - (mobWidth * 0.185)
      });
      $('.ph-cartpage_lineitem-tooltip_arrow').css({
        marginLeft: mobWidth * 0.17
      });
    }
  });

  if ($('.ph-page-cartPage').length > 0) {
    $(document).on('click', '.ph-cartpage__download', function() {
      $('.ph-cartpage__downloadtooltip').toggleClass('hidden');
    });
  }

  function checkouttooltip(tooltiptext) {
    var mobWidthCheckout = $(window).width();

    $(tooltiptext).toggleClass('hidden');

    if (mobWidthCheckout < 768) {
      $(tooltiptext).css({
        width: mobWidthCheckout - 20
      });
    }
  }

  $('.ph-checkoutpage-vatquestionmark').on('click', function() {
    checkouttooltip('.ph-checkoutpage__vattooltip_text');
  });

  $('.ph-checkoutpage-totalquestionmark').on('click', function() {
    checkouttooltip('.ph-checkoutpage__totaltooltip_text');
  });
});
$(document).on('click', '.ph-admin-cartpopup', function() {
  $('.ph-admincontent').toggleClass('hidden');

  var mobWidth = $(window).width();


  if (mobWidth <= 768) {
    $('.ph-admin_crossicon').removeClass('hidden');
  } else {
    $('.ph-admin_crossicon').addClass('hidden');
  }
});
